import { logging } from '../../modules/logging';

export const logger = logging.getLogger('preview');
